import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
//import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Box, Button, Typography, Link, TextField, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, List, ListItem, ListItemAvatar, ListItemText, Avatar, MenuItem } from '@mui/material';
import Pagination from "@mui/material/Pagination";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function CaliforniaBillsPage() {
 const history = useHistory();
 const location = useLocation();
 const [calBills, setCalBills] = useState([]);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");

 const [openDialog, setOpenDialog] = useState(false);
 const [voteType, setVoteType] = useState(null);
 const [comment, setComment] = useState("");
 const [activePostId, setActivePostId] = useState(null);

 const [undoDialogOpen, setUndoDialogOpen] = useState(false);
  const [pendingUndoCaseId, setPendingUndoCaseId] = useState(null);
  const [pendingUndoBill, setPendingUndoBill] = useState(null);

  const [openVotersDialog, setOpenVotersDialog] = useState(false);
  const [activeVoters, setActiveVoters] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");

  const [sortMode, setSortMode] = useState("recent"); // default

  const [loggedInUser, setLoggedInUser] = useState(null);

  const [selectedState, setSelectedState] = useState("CA"); 

  const [cursor, setCursor] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  const observerRef = useRef(null);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
/*
  const STATES = [
    { code: "ALL", label: "All States" },
    { code: "AL", label: "Alabama" },
    { code: "AK", label: "Alaska" },
    { code: "AZ", label: "Arizona" },
    { code: "AR", label: "Arkansas" },
    { code: "CA", label: "California" },
    { code: "CO", label: "Colorado" },
    { code: "CT", label: "Connecticut" },
    { code: "DE", label: "Delaware" },
    { code: "FL", label: "Florida" },
    { code: "GA", label: "Georgia" },
    { code: "HI", label: "Hawaii" },
    { code: "ID", label: "Idaho" },
    { code: "IL", label: "Illinois" },
    { code: "IN", label: "Indiana" },
    { code: "IA", label: "Iowa" },
    { code: "KS", label: "Kansas" },
    { code: "KY", label: "Kentucky" },
    { code: "LA", label: "Louisiana" },
    { code: "ME", label: "Maine" },
    { code: "MD", label: "Maryland" },
    { code: "MA", label: "Massachusetts" },
    { code: "MI", label: "Michigan" },
    { code: "MN", label: "Minnesota" },
    { code: "MS", label: "Mississippi" },
    { code: "MO", label: "Missouri" },
    { code: "MT", label: "Montana" },
    { code: "NE", label: "Nebraska" },
    { code: "NV", label: "Nevada" },
    { code: "NH", label: "New Hampshire" },
    { code: "NJ", label: "New Jersey" },
    { code: "NM", label: "New Mexico" },
    { code: "NY", label: "New York" },
    { code: "NC", label: "North Carolina" },
    { code: "ND", label: "North Dakota" },
    { code: "OH", label: "Ohio" },
    { code: "OK", label: "Oklahoma" },
    { code: "OR", label: "Oregon" },
    { code: "PA", label: "Pennsylvania" },
    { code: "RI", label: "Rhode Island" },
    { code: "SC", label: "South Carolina" },
    { code: "SD", label: "South Dakota" },
    { code: "TN", label: "Tennessee" },
    { code: "TX", label: "Texas" },
    { code: "UT", label: "Utah" },
    { code: "VT", label: "Vermont" },
    { code: "VA", label: "Virginia" },
    { code: "WA", label: "Washington" },
    { code: "WV", label: "West Virginia" },
    { code: "WI", label: "Wisconsin" },
    { code: "WY", label: "Wyoming" },
];*/
  const STATES = [
    { code: "CA", label: "California" },
    { code: "NY", label: "New York" },
];

  useEffect(() => {
        axios.get("/user/me")
            .then(res => setLoggedInUser(res.data))
            .catch(() => setLoggedInUser(null));
    }, []);
/*
 // Fetch bills from backend
 const fetchBills = async () => {
   try {
     setLoading(true);
     //const res = await axios.get("/api/stateBills");
     const res = await axios.get("/api/stateBills", {
      params: { state: selectedState },
    });
     setCalBills(res.data);
     setError("");
   } catch (err) {
     console.error("Error fetching bills:", err);
     setError("Failed to fetch bills");
   } finally {
     setLoading(false);
   }
 };
*/
/*
const fetchBills = async (pageNumber = 1) => {
 try {
   setLoading(true);

   const res = await axios.get("/api/stateBills", {
     params: {
       state: selectedState,
       page: pageNumber,
       limit: 20
     }
   });

   setCalBills(res.data.bills);
   setTotalPages(res.data.totalPages);
   setPage(res.data.currentPage);
   setError("");

 } catch (err) {
   console.error(err);
   setError("Failed to fetch bills");
 } finally {
   setLoading(false);
   setInitialLoading(false);
 }
};*/
// Add sortMode as a fetch param and reset page when sort changes
const fetchBills = async (pageNumber = 1, sort = sortMode) => {
  try {
    setLoading(true);
    const res = await axios.get("/api/stateBills", {
      params: { state: selectedState, page: pageNumber, limit: 20, sort },
    });
    setCalBills(res.data.bills);
    setTotalPages(res.data.totalPages);
    setPage(res.data.currentPage);
    setError("");
  } catch (err) {
    console.error(err);
    setError("Failed to fetch bills");
  } finally {
    setLoading(false);
    setInitialLoading(false);
  }
};


 // Trigger backend sync (optional button)
 const syncBills = async () => {
   try {
     setLoading(true);
     await axios.get("/api/stateBills/sync");
     await fetchBills(); // refresh after sync
   } catch (err) {
     console.error("Error syncing bills:", err);
     setError("Failed to sync bills");
   } finally {
     setLoading(false);
   }
 };



/*
 useEffect(() => {
   fetchBills();
 }, [selectedState]);
*/
/*
useEffect(() => {
 setInitialLoading(true);
 fetchBills(page);
}, [selectedState, page]);*/
// Reset to page 1 whenever state OR sortMode changes
useEffect(() => {
  setInitialLoading(true);
  setPage(1);
  fetchBills(1, sortMode);
}, [selectedState, sortMode]);

// Regular page changes (pagination clicks)
useEffect(() => {
  fetchBills(page, sortMode);
}, [page]);

 //if (loading) return <p className="text-center">Loading bills...</p>;
 if (initialLoading)
  return <p className="text-center">Loading bills...</p>;
 if (error) return <p className="text-center text-red-500">{error}</p>;




 const toggleVote = async (calBillId) => {
  try {
      const res = await axios.post(`/calBill/${calBillId}/upvote`);
      const { upvotes, voted } = res.data;

      setCalBills(prevCalBills => {
          const updated = prevCalBills.map(calBill =>
              calBill._id === calBillId
              ? { ...calBill, upvoteCount: upvotes, voted }
              : calBill
          );

      return updated;

      // Sort again after update
      //return updated.sort((a, b) => b.upvoteCount - a.upvoteCount);
      });
  } catch (err) {
      console.error('Error toggling vote:', err);
  }
  };


/*
 const toggleNoPass = async (calBillId) => {
       try {
           const res = await axios.post(`/calBill/${calBillId}/noPass`);
           const { upvotes, stateBillVoted } = res.data;




           setCalBills(prev =>
               prev.map(calBill => calBill._id === calBillId ? { ...calBill, noPassCount: upvotes, stateBillVoted } : calBill)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };




 const togglePass = async (calBillId) => {
       try {
           const res = await axios.post(`/calBill/${calBillId}/pass`);
           const { upvotes, stateBillVoted} = res.data;




           setCalBills(prev =>
               prev.map(calBill => calBill._id === calBillId ? { ...calBill, passCount: upvotes, stateBillVoted } : calBill)
           );
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };








 const handleOpenDialog = (calBillId) => {
       setActivePostId(calBillId);
       setOpenDialog(true);
   };




 const handleSubmitVote = async () => {
       if (!voteType || !comment.trim() || !activePostId) {
           alert("Please choose vote type and enter a comment.");
           return;
       }




       try {
           await axios.post(`/calBill/${activePostId}/comment`, { text: comment });




           if (voteType === "No Pass") {
               await toggleNoPass(activePostId);
           } else {
               await togglePass(activePostId);
           }
           setOpenDialog(false);
           setComment("");
           setVoteType(null);
       } catch (err) {
           console.error(err);
       }
   };
*/

const isSameUser = (voteUser, loggedInUserId) => {
        if (!voteUser) return false;
        return typeof voteUser === "string"
            ? voteUser === loggedInUserId
            : voteUser._id === loggedInUserId;
    };

  const toggleNoPass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/calBill/${billId}/noPass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setCalBills(prev =>
                prev.map(bill =>
                    bill._id === billId
                    ? {
                        ...bill,

                        // update counts
                        noPassCount: upvotes,

                        votedStateBill: true,
                        votedSide: "no pass",
                        /*billVoted,

                        // update voter list 
                        billVoters: [
                            ...(bill.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record no pass vote
                        noPassPowerVotes: [
                            ...(bill.noPassPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // make sure pass votes does NOT contain user
                        passPowerVotes: (bill.passPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                        }
                    : bill
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const togglePass = async (billId, commentId) => {
        try {
            const res = await axios.post(`/calBill/${billId}/pass`, {commentId});
            const { upvotes, billVoted } = res.data;

            setCalBills(prev =>
                prev.map(bill =>
                    bill._id === billId
                    ? {
                        ...bill,

                        // update counts
                        passCount: upvotes,

                        votedStateBill: true,
                        votedSide: "pass",
                        /*billVoted,

                        // update voter list
                        billVoters: [
                            ...(bill.billVoters || []),
                            {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                        ],

                        // record pass vote
                        passPowerVotes: [
                            ...(bill.passPowerVotes || []),
                            {
                            user: {
                                _id: loggedInUser._id,
                                username: loggedInUser.username,
                                first_name: loggedInUser.first_name,
                                last_name: loggedInUser.last_name,
                                profileImageUrl: loggedInUser.profileImageUrl,
                                tier: loggedInUser.tier,
                            },
                            comment: commentId,
                            },
                        ],

                        // remove from no pass votes if present
                        noPassPowerVotes: (bill.noPassPowerVotes || []).filter(
                            v => !isSameUser(v.user, loggedInUser._id)
                        ),*/
                        }
                    : bill
                )
            );
        } catch (err) {
            console.error('Error toggling vote:', err);
        }
    };

  const handleOpenDialog = (billId) => {
        setActivePostId(billId);
        setOpenDialog(true);
    };

  const handleSubmitVote = async () => {
        if (!voteType || !comment.trim() || !activePostId) {
            alert("Please choose vote type and enter a comment.");
            return;
        }

        try {
            const commentRes = await axios.post(
                `/calBill/${activePostId}/comment`,
                { text: comment }
            );

            const commentId = commentRes.data._id; 

            if (voteType === "NP") {
                await toggleNoPass(activePostId, commentId);
            } else {
                await togglePass(activePostId, commentId);
            }
            setOpenDialog(false);
            setComment("");
            setVoteType(null);
        } catch (err) {
            console.error(err);
        }
    };

    /*
    const handleUndoVote = async (billId, bill) => {
	    const res = await axios.post(`/calBill/${billId}/undoVote`);

        const { upvotes, billVoted } = res.data;

       if (
            bill.noPassPowerVotes?.some(
                vote => isSameUser(vote.user, loggedInUser._id)
            )
            ) {
                setCalBills(prev =>
                    prev.map(c =>
                    c._id === billId
                        ? {
                            ...c,

                            // keep working count logic
                            noPassCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (c.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            noPassPowerVotes: (c.noPassPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            } else if (
                bill.passPowerVotes?.some(
                    vote => isSameUser(vote.user, loggedInUser._id)
                )
            ) {
                setCalBills(prev =>
                    prev.map(c =>
                    c._id === billId
                        ? {
                            ...c,

                            // keep working count logic
                            passCount: upvotes,
                            billVoted,

                            // remove user from arrays so button updates
                            billVoters: (c.billVoters || []).filter(
                                v => !isSameUser(v, loggedInUser._id)
                            ),
                            passPowerVotes: (c.passPowerVotes || []).filter(
                                v => !isSameUser(v.user, loggedInUser._id)
                            ),
                        }
                        : c
                    )
                );
            }
    };*/
    const handleUndoVote = async (billId, bill) => {
        try {
            const res = await axios.post(`/calBill/${billId}/undoVote`);
            const { upvotes } = res.data;

            setCalBills(prev =>
                prev.map(c => {
                    if (c._id !== billId) return c;

                    const updated = { ...c };

                    if (c.votedSide === "no pass") {
                        updated.noPassCount = upvotes;
                    } else if (c.votedSide === "pass") {
                        updated.passCount = upvotes;
                    }

                    updated.votedStateBill = false;
                    updated.votedSide = null;

                    return updated;
                })
            );
        } catch (err) {
            console.error(err);
        }
    };

    /*const openNoPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");
        setActiveVoters(bill.noPassPowerVotes || []);
        setOpenVotersDialog(true);
    };

    const openPassVoters = (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");
        setActiveVoters(bill.passPowerVotes || []);
        setOpenVotersDialog(true);
    };*/
    /*
    const openNoPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("No Pass Votes");

        try {
            const res = await axios.get(`/stateBill/${bill._id}/voters?side=no pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };

    const openPassVoters = async (e, bill) => {
        e.stopPropagation();
        setDialogTitle("Pass Votes");

        try {
            const res = await axios.get(`/stateBill/${bill._id}/voters?side=pass`);
            setActiveVoters(res.data);
            setOpenVotersDialog(true);
        } catch (err) {
            console.error(err);
        }
    };*/

const sortedBills = [...calBills].sort((a, b) => {
        if (sortMode === "popular") {
            return b.upvoteCount - a.upvoteCount;
        }

        // recent
        return (
          new Date(b.last_action_date || 0).getTime() -
          new Date(a.last_action_date || 0).getTime()
        );
    });

    const PAGE_JUMP = 10;

    const jumpBackward = () => {
    setPage(prev => Math.max(prev - PAGE_JUMP, 1));
    };

    const jumpForward = () => {
    setPage(prev => Math.min(prev + PAGE_JUMP, totalPages));
    };

    const navItems = [
      { label: "Popular Opinion", path: "/Government/popular" },
      { label: "Following", path: "/Government/following" },
      { label: "Supreme Court", path: "/Government/SupremeCourt" },
      { label: "Congressional Bills", path: "/Government/CongressionalBills" },
      { label: "State Legislature Bills", path: "/Government/StateBills" },
      { label: "Elections", path: "/Government/Elections/GubernatorialElections" }
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };

 return (
   <div
           style={{
               padding: '20px',
               backgroundColor: '#FFFDF8',
               minHeight: '100vh',  // ensures it covers the full viewport height
               boxSizing: 'border-box', // ensures padding doesn't affect layout
           }}
       >


           <div style={{ width: '200px' }}></div>


           {/* Centered Buttons */}
           {/*<Box
               display="flex"
               justifyContent="center"
               alignItems="center"
               gap={2}
               flexWrap="wrap"
               sx={{
                   mt: 4,
                   mb: 4,
               }}
                   >
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/a')}
                   >
                       Popular Opinion
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/d')}
                   >
                       Following
                   </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/supremeCourtCases')}
                   >
                       Supreme Court
                   </Button>
                   <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        State Legislature Bills
                    </Button>
                   <Button
                       variant="outlined"
                       sx={{
                           padding: "6px 12px",
                           borderColor: "#333333", 
                           color: "#333333",      
                           backgroundColor: "transparent",
                           '&:hover': {
                               borderColor: "black",
                               color: "black",
                               backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                           },
                       }}
                       onClick={() => history.push('/page2/c')}
                   >
                       Elections
                   </Button>


           </Box>*/}
           {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
       <Box display="flex" justifyContent="center" mb={4}>
            <TextField
                select
                size="small"
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                sx={{ minWidth: 180 }}
            >
                {STATES.map(state => (
                <MenuItem key={state.code} value={state.code}>
                    {state.label}
                </MenuItem>
                ))}
            </TextField>
        </Box>
      <Box
                sx={{
                    maxWidth: 900,        // match your case card width
                    mx: "auto",           // center container
                }}
            >
            <Box
                display="flex"
                justifyContent="flex-start"
                gap={1}
                mb={2}
                //sx={{ ml: 2 }}
            >
                <Button
                    size="small"
                    variant={sortMode === "popular" ? "contained" : "outlined"}
                    onClick={() => setSortMode("popular")}
                >
                    High Visibility Bills
                </Button>
                <Button
                    size="small"
                    variant={sortMode === "recent" ? "contained" : "outlined"}
                    onClick={() => setSortMode("recent")}
                >
                    Latest Action Bills
                </Button>
            </Box>

         {calBills.map((calBill, i) => {
           const noPassCount = calBill.noPassCount || 0;
           const passCount = calBill.passCount || 0;
           let votePercentage = 0;
      
           if (passCount > noPassCount) {
               votePercentage = passCount/(passCount+noPassCount)
           } else if (noPassCount > passCount) {
               votePercentage = noPassCount/(passCount+noPassCount)
           }




           let offset = 0;
           if (passCount > noPassCount) {
               offset = votePercentage * 50; // move right
           } else if (noPassCount > passCount) {
               offset = -votePercentage * 50; // move left
           }




           let tickColor = "blue"; // default at center
           if (offset > 0) {
               //tickColor = "#00c853"; // right side
               tickColor = "red"; // right side
           } else if (offset < 0) {
               tickColor = "red"; // left side
           }




           return (
           <Box
               //key={i} // unique key for each list item
               key={calBill._id}
               onClick={() => history.push(`/calBill/${calBill._id}/comments`)}
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
                   cursor: "pointer",
                   "&:hover": {
                       backgroundColor: "#f9f9f9"
                   }
               }}
           >


             {/*<Button
                 onClick={(e) => {
                     e.stopPropagation(); 
                     joinVideoCall(bill._id)}
                 }
                 variant="outlined"
                 size="small"
                 sx={{
                     position: "absolute",
                     top: 8,
                     right: 8,
                     zIndex: 1
                 }}
             >
                 Join Voice Call
             </Button>*/}


           <Typography
                   fontWeight="bold"
                   sx={{
                       wordBreak: "break-word",
                       pr: "140px",
                       mb: 1
                   }}
               >
                   {calBill.number}: {calBill.title}
           </Typography>


          {/*<Typography
                   fontWeight="regular"
                   sx={{
                       wordBreak: "break-word",
                       pr: "140px",
                       mb: 1
                   }}
               >
                   {calBill.description}
           </Typography>*/}

          <Typography variant="body2" component="div">
            <Box component="span" fontWeight="bold">
                Summary:
            </Box>

            <Box
                component="div"
                sx={{ mt: 0.5 }}
                //dangerouslySetInnerHTML={{ __html: calBill.description }}
            >
              {calBill.description}
            </Box>
        </Typography>

        {/*<Typography variant="body2">
            <Box component="span" fontWeight="bold">
                Latest Action:
            </Box>{' '}
            {calBill.last_action
                ? `${calBill.last_action_date} — ${calBill.last_action}`
                : 'No recent action'}
        </Typography>*/}
        {/*<Typography variant="body2">
          <Box component="span" fontWeight="bold">
            Latest Action:
          </Box>{' '}
          {calBill.last_action || calBill.last_action_date ? (
            <>
              {calBill.last_action_date
                ? calBill.last_action_date
                : '—'}{' '}
              — {calBill.last_action || 'Action recorded'}
            </>
          ) : (
            'No recent action'
          )}
      </Typography>*/}
      <Typography variant="body2">
        <Box component="span" fontWeight="bold">
          Latest Action:
        </Box>{' '}
        {calBill.last_action || calBill.last_action_date ? (
          <>
            {calBill.last_action_date
              ? new Date(calBill.last_action_date).toLocaleDateString()
              : '—'}{' '}
            — {calBill.last_action || 'Action recorded'}
          </>
        ) : (
          'No recent action'
        )}
    </Typography>

    {/*<Link
               href={`/api/bill/pdf/${calBill.doc_id}`}
               target="_blank"
               rel="noopener noreferrer"
               onClick={(e) => e.stopPropagation()}
           >
               View Bill
             </Link>*/}
             {calBill.pdf_url && (
                <Link
                    href={calBill.pdf_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                >
                    View Bill
                </Link>
             )}

           {/*<Box
               display="flex"
               justifyContent="center"
               sx={{
                   mb: 2,
                   //my: 1
               }}
           >
               <Button
                   variant="outlined"
                   size="small"
                   onClick={(e) => {
                       e.stopPropagation();
                       handleOpenDialog(calBill._id)}
                   }
                   //sx={{ ml: 1 }}
                   //sx={{ mr: 2.3 }}
                   sx={{ ml: 2.3 }}
               >
                   Vote
               </Button>
           </Box>*/}
          {/*<Box
                display="flex"
                justifyContent="center"
                sx={{ mb: 2 }}
            >
                {loggedInUser &&
                    calBill.billVoters?.some(voter =>
                        isSameUser(voter, loggedInUser._id)
                ) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": {
                            display: "none",
                            },
                            "&:hover .undo-btn": {
                            display: "inline-flex",
                            },
                        }}
                    >
                    {loggedInUser &&
                    calBill.noPassPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted No Pass
                    </Button>
                    ) : loggedInUser && calBill.passPowerVotes?.some(vote =>
                        isSameUser(vote.user, loggedInUser._id)
                    ) ? (
                    <Button
                        className="voted-btn"
                        variant="outlined"
                        size="small"
                        disabled
                        sx={{ ml: 2.3 }}
                    >
                        Voted Pass
                    </Button>
                    ) : null}
                    <Button
                        className="undo-btn"
                        variant="contained"
                        color="error"
                        size="small"
                        sx={{ display: "none", ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setPendingUndoCaseId(calBill._id);
                            setPendingUndoBill(calBill);
                            setUndoDialogOpen(true);
                        }}
                    >
                        Undo Vote
                    </Button>
                </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(calBill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>*/}
            <Box display="flex" justifyContent="center" sx={{ mb: 2 }}>
                {loggedInUser && calBill.votedStateBill ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            "&:hover .voted-btn": { display: "none" },
                            "&:hover .undo-btn":  { display: "inline-flex" },
                        }}
                    >
                        <Button
                            className="voted-btn"
                            variant="outlined"
                            size="small"
                            disabled
                            sx={{ ml: 2.3 }}
                        >
                            {calBill.votedSide === "no pass"
                            ? "Voted No Pass"
                            : "Voted Pass"}
                        </Button>
                        <Button
                            className="undo-btn"
                            variant="contained"
                            color="error"
                            size="small"
                            sx={{ display: "none", ml: 2.3 }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setPendingUndoCaseId(calBill._id);
                                setPendingUndoBill(calBill);
                                setUndoDialogOpen(true);
                            }}
                        >
                            Undo Vote
                        </Button>
                    </Box>
                ) : (
                    <Button
                        variant="outlined"
                        size="small"
                        sx={{ ml: 2.3 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenDialog(calBill._id);
                        }}
                    >
                        Power Vote
                    </Button>
                )}
            </Box>


           {/* Vote bar with tick */}
           <Box
               display="flex"
               alignItems="center"
               justifyContent="center"
               sx={{ mb: 2 }}
               >
               {/* No Pass Votes */}
               <Typography variant="body2">No Pass Votes</Typography>




               {/* Bar with tick in middle */}
               <Box
                   sx={{
                       position: "relative",
                       height: "2px",
                       backgroundColor: "#ccc",
                       width: "300px",
                       mx: 2
                   }}>
                       {/* Tick in the center */}
                       <Box sx={{
                           position: "absolute",
                           top: "-6px",
                           left: "50%",
                           transform: "translateX(-50%)",
                           width: "2px",
                           height: "14px",
                           backgroundColor: "black"
                       }} />
                  
                   {/* Dynamic tick + percentage */}
                   <Box
                       sx={{
                           position: "absolute",
                           top: "-6px",
                           left: `calc(50% + ${offset}%)`,
                           transform: "translateX(-50%)",
                           display: "flex",
                           flexDirection: "column",
                           alignItems: "center"
                       }}
                       >
                       {/* Tick */}
                       <Box sx={{
                           width: "2px",
                           height: "14px",
                           backgroundColor: tickColor
                       }} />




                       {/* Percentage */}
                       <Typography
                           variant="caption"
                           sx={{ mt: "2px", fontSize: "0.7rem" }}
                       >
                           {(votePercentage * 100).toFixed(0)}%
                       </Typography>
                       </Box>
                   </Box>




                   {/* Pass Votes */}
                   <Typography variant="body2">Pass Votes</Typography>
           </Box>
             

             {/* Upvote button & count */}
             <Box mt={2} display="flex" alignItems="center" gap={1}>
               <Button
                   size="small"
                   variant={calBill.voted ? "contained" : "outlined"}
                   onClick={(e) => {
                       e.stopPropagation();
                       toggleVote(calBill._id)}
                   }
               >
                   ▲ {calBill.voted ? "Unvote" : "Upvote"}
               </Button>
               {/*<Typography variant="body2">{calBill.upvoteCount} Visibility Upvotes | {calBill.noPassCount} No Pass Votes | {calBill.passCount} Pass Votes</Typography>*/}
               <Typography variant="body2">
                    {calBill.upvoteCount} Visibility Upvotes |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main",}}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openNoPassVoters(e, calBill)}
                    >
                        {calBill.noPassCount} No Pass Votes
                    </Box>{" "}
                    |{" "}
                    <Box
                        component="span"
                        sx={{ color: "primary.main",}}
                        //sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
                        //onClick={(e) => openPassVoters(e, calBill)}
                    >
                        {calBill.passCount} Pass Votes
                    </Box>
                </Typography>
             </Box>
           </Box>
         );
       })}
       <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={4}
        >
            {/* jump back 10 pages */}
            <Button
                variant="outlined"
                onClick={jumpBackward}
                disabled={page <= 1}
            >
                {"<< 10"}
            </Button>

            <Pagination
                count={totalPages}
                page={page}
                onChange={(event, value) => setPage(value)}
                color="primary"
                size="large"
                siblingCount={1}
                boundaryCount={2}
                //showFirstButton
                //showLastButton
                hidePrevButton 
                hideNextButton
            />

            {/* jump forward 10 pages */}
            <Button
                variant="outlined"
                onClick={jumpForward}
                disabled={page >= totalPages}
            >
                {"10 >>"}
            </Button>
        </Box>
       </Box>
  {/* --- Dialog --- */}
          {/*<Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
              <DialogTitle>Cast Your Power Vote</DialogTitle>
              <DialogContent>
                  <Box display="flex" gap={2} mb={2}>
                      <Button
                          variant={voteType === "No Pass" ? "contained" : "outlined"}
                          onClick={() => setVoteType("No Pass")}
                      >
                          No Pass
                      </Button>
                      <Button
                          variant={voteType === "Pass" ? "contained" : "outlined"}
                          onClick={() => setVoteType("Pass")}
                      >
                          Pass
                      </Button>
                  </Box>
                  <TextField
                      fullWidth
                      multiline
                      rows={3}
                      placeholder="Explain your power vote (required)"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                  />
              </DialogContent>
              <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                  <Button
                      variant="outlined"
                      onClick={handleSubmitVote}
                      disabled={!comment || !voteType}
                  >
                      Submit Power Vote
                  </Button>
              </DialogActions>
          </Dialog>*/}
          <Dialog 
            open={openDialog} 
            onClose={() => setOpenDialog(false)} 
            fullWidth
            PaperProps={{
                sx: {
                backgroundColor: "#FFFDF8",
                borderRadius: 3,
                },
            }}
            >
               <DialogTitle>Cast Your Power Vote</DialogTitle>
                <DialogContent>
                    <Box display="flex" gap={2} mb={2}>
                        <Button
                            variant={voteType === "NP" ? "contained" : "outlined"}
                            onClick={() => setVoteType("NP")}
                        >
                            No Pass
                        </Button>
                        <Button
                            variant={voteType === "P" ? "contained" : "outlined"}
                            onClick={() => setVoteType("P")}
                        >
                            Pass
                        </Button>
                    </Box>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        placeholder="Explain your power vote (required)"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button
                        variant="outlined"
                        onClick={handleSubmitVote}
                        disabled={!comment || !voteType}
                    >
                        Submit Power Vote
                    </Button>
                </DialogActions>
           </Dialog>

           <Dialog
                open={undoDialogOpen}
                onClose={() => setUndoDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                        px: 2,
                        py: 1.5,
                    },
                }}
                >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Undo your vote?
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ color: "text.primary" }}>
                        This will remove your vote and the vote rationale comment associated with it.
                        This action cannot be undone.
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ pb: 2, px: 3 }}>
                    <Button
                        onClick={() => setUndoDialogOpen(false)}
                        variant="outlined"
                        sx={{
                            borderColor: "#d0cfc8",
                            color: "text.primary",
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        onClick={() => {
                            handleUndoVote(pendingUndoCaseId, pendingUndoBill);
                            setUndoDialogOpen(false);
                            setPendingUndoCaseId(null);
                            setPendingUndoBill(null);
                        }}
                        variant="contained"
                        color="error"
                        sx={{
                            boxShadow: "none",
                        }}
                    >
                        Yes, Undo Vote
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openVotersDialog}
                onClose={() => setOpenVotersDialog(false)}
                fullWidth
                maxWidth="xs"
                PaperProps={{
                    sx: {
                        backgroundColor: "#FFFDF8",
                        borderRadius: 3,
                    },
                }}
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    {dialogTitle}
                </DialogTitle>

                <DialogContent dividers>
                    {activeVoters.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No votes
                    </Typography>
                    ) : (
                    <List disablePadding>
                        {activeVoters.map(vote => (
                        <ListItem 
                            key={vote.user._id} 
                            button
                            onClick={(e) => visitProfile(e, vote.user._id)}
                            sx={{
                                px: 0,
                                borderRadius: 2,
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                '&:hover': {
                                    backgroundColor: '#FFF2CC', // subtle highlight
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                }}
                            >
                                {/* Left side: Avatar + user info */}
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemAvatar>
                                    <Avatar src={vote.user.profileImageUrl}>
                                        {vote.user.username?.[0]}
                                    </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={`${vote.user.first_name} ${vote.user.last_name}`}
                                        secondary={`@${vote.user.username}`}
                                    />
                                </Box>
                                <Typography variant="body2" color="text.secondary">
                                    Voting Power: {vote.user.tier}
                                </Typography>
                            </Box>
                        </ListItem>
                        ))}
                    </List>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenVotersDialog(false)}>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


     {/*<ul className="space-y-3">
       {cases.map((scotusCase, i) => (
         <li key={i} className="border p-3 rounded shadow">
           <h2 className="font-semibold">{scotusCase.name}</h2>
           <div className="space-x-4">
             <a href={scotusCase.pdfUrl} target="_blank" rel="noreferrer" className="text-green-600 underline">
               View PDF
             </a>
           </div>
         </li>
       ))}
     </ul>*/}
   </div>
 );
}


export default CaliforniaBillsPage;

/*
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';


function CaliforniaBillsPage() {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");


  // Fetch bills from backend
  const fetchBills = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/stateBills");
      setBills(res.data);
      setError("");
    } catch (err) {
      console.error("Error fetching bills:", err);
      setError("Failed to fetch bills");
    } finally {
      setLoading(false);
    }
  };


  // Trigger backend sync (optional button)
  const syncBills = async () => {
    try {
      setLoading(true);
      await axios.get("/api/stateBills/sync");
      await fetchBills(); // refresh after sync
    } catch (err) {
      console.error("Error syncing bills:", err);
      setError("Failed to sync bills");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchBills();
  }, []);


  if (loading) return <p className="text-center">Loading bills...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;


  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">California Bills (Active)</h1>
        <button
          onClick={syncBills}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Refresh
        </button>
      </div>


      <ul className="space-y-4">
        {bills.map((bill) => (
          <li
            key={bill.bill_id}
            className="p-4 border rounded-lg shadow-sm bg-white"
          >
            <h2 className="text-lg font-semibold">
              {bill.number}: {bill.title}
            </h2>
            <p className="text-gray-700">{bill.description}</p>
            <p className="text-sm text-gray-500 mt-1">
              Status: {bill.status} | Last Action: {bill.last_action} (
              {new Date(bill.last_action_date).toLocaleDateString()})
            </p>

            <a href={`/api/bill/pdf/${bill.doc_id}`} target="_blank" rel="noopener noreferrer">
                View Bill 
            </a>

          </li>
        ))}
      </ul>
    </div>
  );
}


export default CaliforniaBillsPage;
*/